// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AuthTitle_wrapper__PdzK5","wrapper-noBorder":"AuthTitle_wrapper-noBorder__3xCH2","authTitle":"AuthTitle_authTitle__2RXW5"};